
import i18n from "./../../i18n";
export default{
  Shopify: {
    setupDescription: i18n.t('signupflow.step-2.connectors.shopify.description'),
    guideText: i18n.t('signupflow.step-2.connectors.shopify.guide-text'),
    guideLink : i18n.t('signupflow.step-2.connectors.shopify.guide-link'),
    form : [
      {
        default: "",
        description: "Your shop url",
        id: "url",
        mandatory: true,
        name: "Url",
        placeholder: "myshop.com",
        type: "Text",
        focus: true
      },
      {
        applySearchButton: false,
        default: "",
        description: "Your Access token",
        id: "apiPassword",
        mandatory: false,
        name: "Access Token",
        placeholder: "shpa_****",
        type: "Text"
      },
    ]
  },
  WooCommerce: {
    setupDescription: i18n.t('signupflow.step-2.connectors.woocommerce.description'),
    guideText: i18n.t('signupflow.step-2.connectors.woocommerce.guide-text'),
    guideLink : i18n.t('signupflow.step-2.connectors.woocommerce.guide-link'),
    form : [
      {
        default: "",
        description: "Your shop url",
        id: "url",
        mandatory: true,
        name: "Url",
        placeholder: "myshop.com",
        type: "Text",
        focus: true
      },
      {
        default: "",
        description: "Your Consumer key",
        id: "apiKey",
        mandatory: false,
        name: "Consumer key",
        placeholder: "ck_913****",
        type: "Text"
      },
      {
        default: "",
        description: "Your Consumer Secret",
        id: "apiPassword",
        mandatory: false,
        name: "Consumer secret",
        placeholder: "cs_ba3****",
        type: "Text"
      },
    ]
  },
  DanDomainClassic : {
    setupDescription: i18n.t('signupflow.step-2.connectors.dandomain.description'),
    guideText: i18n.t('signupflow.step-2.connectors.dandomain.guide-text'),
    guideLink : i18n.t('signupflow.step-2.connectors.dandomain.guide-link'),
    form : [
      {
        default: "",
        description: "Your shop url",
        id: "url",
        mandatory: true,
        name: "Url",
        placeholder: "myshop.com",
        type: "Text",
        focus: true
      },
      {
        applySearchButton: false,
        default: "",
        description: "Your Access token",
        id: "apiKey",
        mandatory: false,
        name: "Access Token",
        placeholder: "bb435*****",
        type: "Text"
      },
    ]
  },
  Magento2: {
    setupDescription: i18n.t('signupflow.step-2.connectors.magento.description'),
    guideText: i18n.t('signupflow.step-2.connectors.magento.guide-text'),
    guideLink : i18n.t('signupflow.step-2.connectors.magento.guide-link'),
    form : [
      {
        default: "",
        description: "Your shop url",
        id: "url",
        mandatory: true,
        name: "Url",
        placeholder: "myshop.com",
        type: "Text",
        focus: true
      },
      {
        applySearchButton: false,
        default: "",
        description: "Your Access token",
        id: "apiKey",
        mandatory: false,
        name: "Access Token",
        placeholder: "bb435****",
        type: "Text"
      },
    ]
  },
  Shoporama: {
    setupDescription: i18n.t('signupflow.step-2.connectors.shoporama.description'),
    guideText: i18n.t('signupflow.step-2.connectors.shoporama.guide-text'),
    guideLink : i18n.t('signupflow.step-2.connectors.shoporama.guide-link'),
    form : [
      {
        default: "",
        description: "Your shop url",
        id: "url",
        mandatory: true,
        name: "Url",
        placeholder: "myshop.com",
        type: "Text",
        focus: true
      },
      {
        applySearchButton: false,
        default: "",
        description: "Your Access token",
        id: "apiKey",
        mandatory: false,
        name: "Access Token",
        placeholder: "bb435****",
        type: "Text"
      },
    ]
  },

  
  
  
}